(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('.lolli-back-to-top');
    if (!button) return;

    const updateButton = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const triggerPoint = isDesktop ? 700 : Math.max(400, scrollableHeight * 0.6);
      const shouldShow = window.scrollY >= triggerPoint;

      button.classList.toggle('is-visible', shouldShow);
    };

    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });

    window.addEventListener('scroll', updateButton, { passive: true });
    window.addEventListener('resize', updateButton);
    updateButton();
  })();
  } catch(e) { console.error(e); }
})();

})();
